import React from 'react';
import _ from 'lodash';

import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles, createStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';


const singleLoaderStyles = (theme: Theme) => createStyles({
    singleLoaderContainer: {
        background: 'rgba(255,255,255,0.8)',
        width: '100%',
        height: '100%',
        zIndex: 9999,
    },
    singleLoaderProgress: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        marginTop: '-12px',
        marginLeft: '-12px'
    },
});

const LoaderComponent = (props: any) => {
    const {classes} = props 
    return <div className={classes.singleLoaderContainer}>
        <CircularProgress className={classes.singleLoaderProgress} />
    </div>
}

export default withStyles(singleLoaderStyles)(LoaderComponent)
